import { MuiIconMap, MuiIconMetadata } from '@ally/metronome-icons'
// TODO: Remove this icon after Metronome v26 upgrade, icon is provided in newer Metronome versions
const muiCardBase: MuiIconMetadata = {
  paths: [
    {
      path:
        'M16,1.625 L16,11.375 C16,11.821875 15.84336,12.2044 15.53,12.5226563 C15.21664,12.8409125 14.84,13 14.4,13 L1.6,13 C1.16,13 0.783336,12.8409125 0.47,12.5226563 C0.156664,12.2044 0,11.821875 0,11.375 L0,1.625 C0,1.178125 0.156664,0.795575625 0.47,0.47734375 C0.783336,0.159111875 1.16,0 1.6,0 L14.4,0 C14.84,0 15.21664,0.159111875 15.53,0.47734375 C15.84336,0.795575625 16,1.178125 16,1.625 Z M1.6,3.25 L14.4,3.25 L14.4,1.625 L1.6,1.625 L1.6,3.25 Z M1.6,6.5 L1.6,11.375 L14.4,11.375 L14.4,6.5 L1.6,6.5 Z',
      fill: 'plum',
    },
  ],
  title: 'credit card',
  width: 18,
  height: 18,
  rotate: 0,
}

export const muiCreditCard: MuiIconMap = {
  base: muiCardBase,
}
